import React from 'react'
import styled from '@emotion/styled'
import theme from '@nextretreat/ui-components/dist/Theme'
import PropTypes from 'prop-types'
import { BOXSHADOWS, mq } from 'Theme'
import { TOPBAR_HEIGHT } from 'constants/constants'

const StyledTopbar = styled('header')`
  display: flex;
  align-items: center;

  height: ${TOPBAR_HEIGHT};

  box-shadow: ${BOXSHADOWS.DARK};
  background-color: ${theme.COLORS.WHITE};
  ${mq.from.tablet`
      justify-content: space-between;
  `}
`

const Topbar = ({ className, children }) => (
  <StyledTopbar className={className}>{children}</StyledTopbar>
)

Topbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Topbar
